import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { BlankLayoutComponent } from './layouts/blank-layout/blank-layout.component';

const routes: Routes = [
  // ⚠️ 'blank' DEBE ir antes de la ruta '' del MainLayout.
  // Angular hace prefix matching y no hace backtracking entre rutas hermanas:
  // si '' matchea primero, WebPageModule intenta resolver 'blank/...' y falla.
  {
    path: 'blank',
    component: BlankLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./modules/blank/blank.module').then(m => m.BlankModule)
      }
    ]
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./modules/web-page/web-page.module').then(m => m.WebPageModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
